import React from 'react';
import SnackBarMessage from '../SnackBarMessage';
import { useNotification } from '../../../context/NotificationContext';

export const NotificationContainer = () => {
  const { notifications, hideNotification } = useNotification();

  if (!notifications.length) {
    return null;
  }

  return (
    <div className="notification-container">
        {notifications.map(notification => (
        <SnackBarMessage
          key={notification.id}
          message={notification.message}
          type={notification.type}
          onHide={() => hideNotification(notification.id)} 
        />
      ))}

    </div>
  );
};